// extracted by mini-css-extract-plugin
module.exports = {"bladeFooter":"BladeFooter_bladeFooter__2AKvW"};